const MdmMacWelcomeExperienceMainPanel = () => import('client/MDM/MdmWelcomeExperienceMainPanel.vue');

const MdmTitle = 'MDM';

export default [
  {
    path: '/mdm/mac',
    name: 'macWelcome',
    meta: { title: MdmTitle },
    components: {
      mainPanel: MdmMacWelcomeExperienceMainPanel,
    },
  },
];
